// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

import type { GetBotTrackingSettingsResult, PostBotTrackingSettingsResult } from "./types";

export const isGetBotTrackingSettingsResult = objectOf<GetBotTrackingSettingsResult>({
  enable_email_bot_click_filtering: boolean,
  last_updated_at: maybe(string, true),
});

export const isPostBotTrackingSettingsResult = objectOf<PostBotTrackingSettingsResult>({
  success: boolean,
});
